import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import ListItem from '@mui/material/ListItem';

import { ITEM_DESCRIPTION_AND_PRICES } from 'styles/constants/appearanceSectionNames';
import {
  DinerInfoContainer,
  StyledBorder,
  StyledDinerName,
  StyledDinerAction,
  StyledAccountCircleIcon
} from 'bento-ordering/group_ordering/ui_components/CartGroupOrder';
import CartGroupOrderItems from 'bento-ordering/group_ordering/components/CartGroupOrderItems';

import { selectIsFetchingAddToCart } from 'bento-ordering/cart/selectors/index';

import CartItemSkeleton from 'bento-ordering/cart/components/CartItemSkeleton';

export const AdminDinerInfo = ({ diner }) => (
  <>
    <StyledBorder width="16px" />
    <Box display="flex" alignItems="center">
      <StyledAccountCircleIcon />
      <StyledDinerName variant={ITEM_DESCRIPTION_AND_PRICES}>
        {diner.name}
      </StyledDinerName>
      <StyledDinerAction>You</StyledDinerAction>
    </Box>
    <StyledBorder flexGrow={1} />
  </>
);

AdminDinerInfo.propTypes = {
  diner: PropTypes.shape({
    name: PropTypes.string.isRequired
  })
};

const AdminItems = ({
  adminDiner,
  getEditCartItemPath,
  removeItemFromCart,
  handleEditClick,
  currentCartPath
}) => {
  const isCartFetching = useSelector(selectIsFetchingAddToCart);

  return (
    <>
      <DinerInfoContainer>
        <AdminDinerInfo diner={adminDiner} />
      </DinerInfoContainer>
      <CartGroupOrderItems
        items={adminDiner?.items}
        getEditCartItemPath={getEditCartItemPath}
        removeItemFromCart={removeItemFromCart}
        handleEditClick={handleEditClick}
        currentCartPath={currentCartPath}
      />
      {isCartFetching && (
        <ListItem disableGutters divider>
          <CartItemSkeleton />
        </ListItem>
      )}
    </>
  );
};

AdminItems.propTypes = {
  adminDiner: PropTypes.shape({
    items: PropTypes.array.isRequired
  }),
  getEditCartItemPath: PropTypes.func,
  removeItemFromCart: PropTypes.func,
  handleEditClick: PropTypes.func,
  currentCartPath: PropTypes.string
};

export default AdminItems;
